module.exports = "/static/assets/9b76d6a33034ea42a6c2261fa42f73d9.png";